import * as React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { ChevronLeft } from '@lendi-ui/icon';
import { my, px } from '@lendi-ui/spacing';
import { link } from '@lendi-ui/typography';
import { display } from '@lendi-ui/utils';
import { eventTracking } from '../../utils';

const StyledLink = styled.a`
  ${display({ mobile: 'none', desktop: 'block' })}
  ${link({ size: 'sm' })}
  ${my('md')}
  ${px('xxxs')}
  display: inline-block;
  text-decoration: none;
  > * {
    vertical-align: middle;
  }
`;

const BackLink = () => (
  <Link as="/inspire" href="/" passHref>
    <StyledLink
      onClick={() => {
        eventTracking('above-fold', 'navigate', 'Back to Inspire Home');
      }}
    >
      <ChevronLeft color="primary.500" /> Back to Inspire Home
    </StyledLink>
  </Link>
);

export default BackLink;
